// Puts `text` on the clipboard; true if it worked. The modern clipboard API is tried
// first. Some browsers (in-app browsers such as the ones inside social apps, older
// phones, a page that isn't focused) refuse it, so it falls back to selecting the
// text in a hidden field and using the old copy command.
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // fall through to the older way
  }

  try {
    const field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.top = "0";
    field.style.left = "0";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, text.length);
    const copied = document.execCommand("copy");
    document.body.removeChild(field);
    return copied;
  } catch {
    return false;
  }
}
